import SettingHeader from "./SettingHeader";

export default SettingHeader;
